//Node Modules
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLoaderData } from "react-router";
import { useRecoilState, useRecoilValueLoadable } from "recoil";

//GraphQL

//Pages

//BinaryForge Components
import { PageHeader } from "../../../components/layout";
import { Note } from "../../../components/helpers";
import { UserDetailsSkeleton } from "../../../components/helpers/skeleton";
import UserForm from "./UserForm";

//3rd Party Components
import { Button } from "primereact/button";

//Atoms
import { selectedUserAtom, selectedUserSelector } from "../../../atoms/user";

//Helpers

//GraphQL

const UserEdit = () => {
	//Hooks
	const { t } = useTranslation();
	const { username, isAdmin } = useLoaderData();
	const formRef = useRef();

	//Recoil
	const [selectedUser, setSelectedUser] = useRecoilState(selectedUserAtom);
	const { state: selectedUserState, contents: selectedUserData } = useRecoilValueLoadable(selectedUserSelector);

	//On Page Load
	useEffect(() => {
		if (!selectedUser) {
			setSelectedUser({ username: username });
		}
	}, []);

	//Render the User Details
	const PageBody = () => {
		switch (selectedUserState) {
			case "hasError":
				return (
					<Note
						messageKey={`Error: ${selectedUserData.message ? selectedUserData.message : selectedUserData}`}
						icon="pi-exclamation-circle fontColour-error"
					/>
				);
			case "loading":
				return <UserDetailsSkeleton />;
			case "hasValue":
				return <UserForm type="edit" userData={selectedUserData} ref={formRef} />;
			default:
				return null;
		}
	};

	return (
		<>
			<PageHeader
				title={isAdmin ? t("admin.user.edit.pageTitle") : t("user.edit.pageTitle")}
				subtitle={t("user.edit.pageSubtitle", { username: username })}
				enableBack
			/>
			<main className="appMain">
				<div className="appMain-content">
					<div className="flex jContent-end gap-small">
						<Button
							className="feature"
							label={t("user.edit.actions.submit")}
							icon="pi pi-save"
							onClick={() => formRef.current.submitUserForm()}
						/>
					</div>
					<PageBody />
				</div>
			</main>
		</>
	);
};

export default UserEdit;
